import React from "react";
import {BrowserRouter} from 'react-router-dom';
import keycloak from './keycloak';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { ConfigProvider, theme} from 'antd';
import { setChonkyDefaults } from 'chonky';
import { ChonkyIconFA } from 'chonky-icon-fontawesome';
import 'leaflet/dist/leaflet.css'

import MyRoutes from './routes/MyRoutes';
import { Provider } from 'react-redux';
import store from './store';
import { NotificationProvider } from './components/NotificationBox';
import { useAppTheme } from './hooks/useAppTheme';

function App() {
  const { isLight } = useAppTheme();

  const asciiArt = `
  ª▓▓
╓æ
╔▓▓▓       ,æ▓▓w
g▓▓▓      ╥▓▓╣╣╢╢▓
,▓▓▀     ╔▓╣╣╣╢╢▓╩\`
╓▓▓    ╓▓╣╣╣╣╣▓▀         ,╔▓▓@
▓"   ╓▓╣╣╣╣╣▓\`         ╦▓╢╢╢╢╢▓
▓▓█  ▓╣╣╣╣╣▓           ╫╢╢╢╢╢▓╩
▓▓▓µ▓╣╣╣╣▓█▓█▄    ╓▓▓▓╗ ╨▓▓╝
█▓█╢╣╣╣╢▓▓▓▓▓▓▌╓▓╢╢╢╢╢╢
▐▓▌╣╣╢╢██████▓╢╢╢╢╢╢▓╝
█▌╢╢╢█████▀╢╢╢╢╢╢▓\`   ██████████ ,▄████████▄     4▓@     ██████████ ██F      ██
▀╢╢╣████▒╢╢╢╢╢╝      ██▄▄▄▄▄▄▄  ██▌      ▐█▌  ,▓╣╜ ╔φ   ██▄▄▄▄▄▄▄  ██▌      ██
╙▓╢███▌╢╢╢╢▓        ██▀▀▀▀▀▀▀  ██▌      ▐█▌ Æ╣╣▄╖╖▓╢W╖ ██▀▀▀▀▀▀▀  ██▌      ██
╙╣███╢╢╢▓         ██████████ '▀████████▀  \`\`\`\`\`\`▓▓P\` ██████████ '▀████████▀
▀██▒╢▓
▀╙╩ªw.     U = .   . .. \` -<   \`      .∩ Ω   =''   = ^ .   =.~\`   ./
`;
  console.log(asciiArt);
  setChonkyDefaults({iconComponent:ChonkyIconFA});

  const keycloakProviderInitConfig = {
    onLoad: 'login-required',
    checkLoginIframe: false
  }
  
  const { darkAlgorithm, defaultAlgorithm } = theme;

  return (
    <ReactKeycloakProvider authClient={keycloak} initOptions={keycloakProviderInitConfig}>
          <Provider store={store}>

      <ConfigProvider
            theme={{
                algorithm: isLight ? defaultAlgorithm : darkAlgorithm,
                token: {
                    "colorPrimary": "#418cc0",
                    "fontSize": 15,
                    "borderRadius": 14,
                    ...(isLight
                      ? {
                          colorBgLayout: '#f6f7fb',
                          colorBgContainer: '#ffffff',
                        }
                      : {}),
                }
            }}
        >
          <BrowserRouter>
            <NotificationProvider>
              <MyRoutes/>
            </NotificationProvider>
          </BrowserRouter>
      </ConfigProvider>
      </Provider>

    </ReactKeycloakProvider>
  );
}

export default App;
